<button
  type="button"
  class="btn btn-sm btn-light d-flex align-items-center gap-1 chat-status-button px-1"
  [class.chat-status-button--compact]="compact"
  (click)="open()"
  [attr.aria-label]="'chat.status.open' | translate"
>
  @if (view.emoji) {
    <span class="chat-status-button__emoji flex-shrink-0">{{ view.emoji }}</span>
  }

  @if (!compact) {
    @if (view.text) {
      <span class="chat-status-button__text text-truncate">{{ view.text }}</span>
    } @else {
      <span class="chat-status-button__text text-truncate">{{ availabilityLabel | translate }}</span>
    }
    <i class="ri-arrow-down-s-line flex-shrink-0"></i>
  }
</button>
